import { union } from 'lodash-es'
import create from 'zustand'
import shallow from 'zustand/shallow'

// 存储是否选择新建绑定用户
const useStore = create((set) => ({
  isCreateAreaBind: false,
  isBatchDelete: false,
  isMulti: false,
  areaBindType: null, // user | standard
  ruleId: null,
  ruleName: null,
  objectIdsBindedList: [],
  bindedIdsMap: {},
  setBindedList: (id, list) =>
    set(({ bindedIdsMap, objectIdsBindedList }) => {
      const config = { ...bindedIdsMap }
      const userIds = list
      const setConfig = (objectId) => {
        config[objectId] = userIds
      }
      if (Array.isArray(id)) {
        id.forEach(setConfig)
      } else if (id) {
        setConfig(id)
      }
      return {
        bindedIdsMap: config,
        objectIdsBindedList: union(objectIdsBindedList, Object.keys(config)),
      }
    }),
  clearBindedUserMap: () =>
    set(() => ({
      bindedIdsMap: {},
      objectIdsBindedList: [],
    })),
  setAreaState: (state) => set(() => state),
}))

const useAreaStore = (selector, equalityFn = shallow) =>
  useStore(selector, equalityFn)

export default useAreaStore
